<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15pC1Lr/tc-custom/9783988262974.jpg?1704424798135" alt="This image is the cover for the book With Washington in the West, or, A Soldier Boy's Battles the Wilderness, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">With Washington in the West, or, A Soldier Boy's Battles the Wilderness, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>With Washington in the West is a historical fiction novel written by Edward Stratemeyer and published in 1892. The story is set during the American Revolutionary War and follows the adventures of a young soldier named David Morris, who fights alongside George Washington in the battles of the wilderness. The novel begins with David Morris, a young man from New Jersey, enlisting in the Continental Army and joining General George Washington's forces. He quickly proves himself to be a brave and skilled soldier, and is soon sent on a series of dangerous missions deep in the wilderness of the American frontier. As he journeys deeper into enemy territory, David must face a range of dangers and obstacles, including fierce battles with British soldiers and their Native American allies, harsh weather conditions, and treacherous terrain. Along the way, he forms close bonds with his fellow soldiers and learns important lessons about courage, loyalty, and sacrifice. Throughout the novel, Stratemeyer offers a vivid and highly detailed portrait of life during the American Revolutionary War, with all its hardships, heroism, and political intrigue. He also explores a range of themes, including the nature of patriotism and sacrifice, the importance of friendship and camaraderie, and the power of determination and perseverance. "With Washington in the West" is a classic work of historical fiction that has been widely praised for its engaging characters, vivid descriptions, and exciting plot. It is a thrilling and action-packed story of adventure, heroism, and patriotism, and remains a beloved classic of the genre.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Stratemeyer
      </h2>
      
      <p class="authorDescription body article">Edward Stratemeyer (1862-1930) was an American publisher and writer who created some of the most popular and enduring children's book series of the 20th century. He was born in Elizabeth, New Jersey, and grew up in a family of booksellers. Stratemeyer's success as a writer led him to found his own publishing company, the Stratemeyer Syndicate, in 1906. The company employed a team of writers who produced series of books that were marketed to children and teenagers. The Syndicate's most popular series included the Hardy Boys, Nancy Drew, and Tom Swift, among others. Stratemeyer was known for his business savvy and his ability to create books that were both entertaining and wholesome. His books emphasized clean living, honesty, and good citizenship, and they became a staple of children's literature in the 20th century. Even today, many of the series that Stratemeyer created are still in print and continue to be enjoyed by young readers around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?276464f4